import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FileShortSummary,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files`;

export interface GetFilesByOrderIdQueryArgs {
  orderId: string;
}

export const getFilesByOrderIdRequest = (
  payload: GetFilesByOrderIdQueryArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.orderId}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getFilesByOrderIdQuery = async (
  payload: GetFilesByOrderIdQueryArgs,
): Promise<BackResponse<FileShortSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileShortSummary[]>>(
      getFilesByOrderIdRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
